var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 49,
    viewBox: "0 0 37 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 47.0625C2.93755 27.375 0.50005 25.3125 0.50005 18C0.50005 8.06247 8.4688 -3.05176e-05 18.5 -3.05176e-05C28.4375 -3.05176e-05 36.5 8.06247 36.5 18C36.5 25.3125 33.9688 27.375 20.2813 47.0625C19.4375 48.375 17.4688 48.375 16.625 47.0625ZM18.5 25.5C22.625 25.5 26 22.2187 26 18C26 13.875 22.625 10.5 18.5 10.5C14.2813 10.5 11 13.875 11 18C11 22.2187 14.2813 25.5 18.5 25.5Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b64d178d574938045916f949e4d6832d.svg";
export { ForwardRef as ReactComponent };